import React, { useEffect } from 'react';

const ImageModal = ({ image, onClose }) => {
  useEffect(() => {
    // Prevent scrolling when modal is open
    document.body.style.overflow = 'hidden';

    // Cleanup function to restore scrolling when modal is closed
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex justify-center items-center p-4">
      <div
        className="absolute inset-0 bg-black bg-opacity-90 backdrop-blur-2xl transition-all duration-500"
      ></div>
      <div className="relative z-10 transform transition-all duration-500 ease-out"
        style={{
          opacity: 1,
          transform: 'scale(1)',
          maxHeight: 'calc(100vh - 2rem)',
          maxWidth: 'calc(100vw - 2rem)'
        }}
      >
        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 sm:-top-4 sm:-right-4 w-7 h-7 sm:w-8 sm:h-8 bg-white rounded-full shadow-lg flex items-center justify-center group hover:bg-[#4B3BFF] transition-all duration-300 transform hover:scale-110 hover:rotate-90 z-20"
        >
          <svg
            className="w-3 h-3 sm:w-4 sm:h-4 text-gray-600 group-hover:text-black transition-colors duration-300"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <div className="bg-white rounded-lg shadow-xl overflow-hidden">
          <img
            src={image.src}
            alt={image.alt}
            className="w-auto h-auto object-contain"
            style={{
              maxHeight: 'calc(100vh - 4rem)',
              maxWidth: 'calc(100vw - 2rem)'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageModal; 